import { Injectable } from '@angular/core';
import { DateRange } from '../interfaces/dateRange';

@Injectable()
export class DatePresetsSelectorService {
	private _preset: string;
	private _statsDate: DateRange;

	constructor() {
		this.preset = 'today';
	}

	set preset(preset: string) {
		this._preset = preset;
	}

	get preset() {
		return this._preset;
	}

	set statsDate(statsDate: DateRange) {
		this._statsDate = statsDate;
	}

	get statsDate() {
		return this._statsDate;
	}

	getDateRangeFromPreset(preset: string, minDate?: Date) {
		let startDate = new Date();
		let endDate = new Date();
		const timeChanged = false;

		switch (preset) {

			case 'today':
				break;

			case 'yesterday':
				endDate.setDate(startDate.getDate() - 1);
				startDate.setDate(startDate.getDate() - 1);
				break;

			case 'last-24-hours':
				startDate.setDate(startDate.getDate() - 1);
				break;

			case 'last-48-hours':
				startDate.setDate(startDate.getDate() - 2);
				break;

			case 'last-72-hours':
				startDate.setDate(startDate.getDate() - 3);
				break;

			case 'last-7-days':
				endDate.setDate(endDate.getDate() - 1);
				startDate.setDate(startDate.getDate() - 7);
				break;

			case 'last-30-days':
				endDate.setDate(endDate.getDate() - 1);
				startDate.setDate(startDate.getDate() - 30);
				break;

			case 'last-week':

				endDate.setDate(endDate.getDate() - endDate.getDay());
				startDate.setDate(startDate.getDate() - startDate.getDay() - 6);
				break;

			case 'last-month':
				startDate.setDate(1);
				startDate.setMonth(endDate.getMonth() - 1);
				endDate.setDate(0);
				break;

			case 'last-quarter':

				const month = Math.floor((startDate.getMonth() / 3) - 1) * 3;
				startDate.setMonth(month);
				startDate.setDate(1);

				endDate.setMonth(month + 3);
				endDate.setDate(0);
				break;

			case 'last-6-months':
				startDate.setMonth(startDate.getMonth() - 6);
				endDate.setDate(endDate.getDate() - 1);
				break;

			case 'last-year':
				startDate.setFullYear(startDate.getFullYear() - 1);
				startDate.setMonth(0);
				startDate.setDate(1);

				endDate.setFullYear(endDate.getFullYear() - 1);
				endDate.setMonth(11);
				endDate.setDate(31);
				break;

			case 'week-to-date':
				startDate.setDate(startDate.getDate() - startDate.getDay() + 1);
				endDate.setDate(endDate.getDate() - 1);
				break;

			case 'month-to-date':
				startDate.setDate(1);
				endDate.setDate(endDate.getDate() - 1);
				break;

			case 'quarter-to-date':
				const currentQuartermonth = Math.floor((startDate.getMonth() / 3) + 1) * 2;
				startDate.setMonth(currentQuartermonth);
				startDate.setDate(1);

				endDate.setDate(endDate.getDate() - 1);
				break;

			case 'year-to-date':
				startDate.setDate(1);
				startDate.setMonth(0);
				endDate.setDate(endDate.getDate() - 1);
				break;
		}

		if (preset && preset !== 'custom' && preset.indexOf('hours') !== -1) {
			const hour = startDate.getHours();
			endDate.setHours(hour, 0, 0, 0);
			startDate.setHours(hour, 0, 0, 0);
		} else if (!timeChanged) {
			startDate.setHours(0, 0, 0, 0);
			if (preset !== 'today') {
				endDate.setHours(23, 59, 59, 999);
			}
		}
		// console.warn('startDate, endDate', startDate, endDate, 'preset', preset);

		let datesCorrected = false;

		if (minDate && startDate.getTime() < minDate.getTime()) {
			startDate = new Date(minDate);
			datesCorrected = true;
		}

		if (minDate && endDate.getTime() < minDate.getTime()) {
			endDate = new Date(minDate);
			datesCorrected = true;
		}

		return {
			startDate, endDate
		};
	}

}
